import api from '../../api/api';
import { playlistApi } from '../../api/playlist';

export function recentPlaylistArtwork(item, detail) {
  const supplied = [...new Set((item.imageUrls || []).filter(Boolean))];
  const detailImages = [...(detail?.albums || []), ...(detail?.tracks || [])]
    .sort((a, b) => a.position - b.position)
    .map((entry) => entry.albumImageUrl)
    .filter(Boolean);
  return {
    imageUrl: item.imageUrl?.trim() || detail?.imageUrl?.trim(),
    previewImageUrls: [...new Set([...supplied, ...detailImages])].slice(0, 4),
  };
}
export function needsRecentPlaylistArtwork(item) {
  return item.kind === 'playlist' && !item.imageUrl?.trim() && !item.imageUrls?.some(Boolean);
}
export function recentAlbumRequest(item) {
  if (!['album', 'review'].includes(item.kind)) return null;
  const segments = item.path.split('?')[0].split('/').filter(Boolean);
  if (segments[0] !== 'reviews' || !segments[1]) return null;
  if (['local', 'apple_music', 'spotify'].includes(segments[1]) && segments[2]) {
    let id;
    try {
      id = decodeURIComponent(segments[2]);
    } catch {
      return null;
    }
    return segments[1] === 'local'
      ? { path: `/albums/${segments[2]}` }
      : { path: '/albums', params: { type: segments[1], id } };
  }
  return { path: `/albums/by-slug/${segments[1]}` };
}
export async function readRecentRating(item, signal) {
  const request = recentAlbumRequest(item);
  const response = await api.getAuth(request.path, {
    params: request.params,
    signal,
    timeout: 15000,
    suppressGlobalError: true,
  });
  return response.data?.data?.contentRating ?? null;
}
export async function readRecentPlaylist(item, signal) {
  const key = item.path.split('?')[0].split('/')[2];
  const config = { signal, timeout: 15000, suppressGlobalError: true, optionalAuth: true };
  const response = /^\d+$/.test(key)
    ? await playlistApi.getPlaylistById(key, config)
    : await playlistApi.getPlaylistBySlug(key, config);
  return response.data;
}
